export const PaySlip = {
    path: '/pay_slips',
    name: 'pay_slips',
    component: () => import('@/views/PaySlip/PaySlipPage.vue'),
    children: [
        {
            path: '/pay_slips/generate',
            name: 'pay_slips.generate',
            component: () => import('../views/PaySlip/Form/GeneratePaySlip.vue'),
        },
        {
            path: '/pay_slips/add_pay_sections/:annexId',
            name: 'pay_slips.add_pay_sections',
            component: () => import('../views/PaySlip/Form/PaySectionsManage.vue'),
            props: {addAction: true}
        },
        {
            path: '/pay_slips/delete_pay_sections/:annexId',
            name: 'pay_slips.delete_pay_sections',
            component: () => import('../views/PaySlip/Form/PaySectionsManage.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/pay_slips/import/:annexId',
            name: 'pay_slips.import',
            component: () => import('../views/PaySectionImport/Form/ImportValueForm.vue'),
        },
        {
            path: '/pay_slips/correct/:id/:annexId',
            name: 'pay_slips.correct',
            component: () => import('@/views/PaySlip/Form/CorrectionForm.vue'),
        },
        {
            path: '/pay_slips/view/:id',
            name: 'pay_slips.view',
            component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
        },
         {
            path: '/pay_slips/balance/view/:id',
            name: 'pay_slips.balance.pay_slip.view',
            component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
        },
        {
            path: '/pay_slips/balance/request/view/:id',
            name: 'pay_slips.balance.request.view',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/pay_slips/close/:id',
            name: 'pay_slips.close',
            component: () => import('@/views/PaySlip/Form/CloseForm.vue'),
        },
        {
            path: '/pay_slips/annex/close/:id',
            name: 'pay_slips.annex.close',
            component: () => import('@/views/PaySlipSynthesis/Form/CloseForm.vue'),
        },
        {
            path: '/pay_slips/delete/:id',
            name: 'pay_slips.delete',
            component: () => import('@/views/PaySlip/Form/DeleteForm.vue'),
        },
        {
            path: '/pay_slips/create_empty_one/worker/:workerId/:annexId',
            name: 'pay_slips.create_empty_one',
            component: () => import('@/views/PaySlip/Form/CreateEmptyOne.vue'),
        },
        {
            path: '/pay_slips/workers/edit/:id',
            name: 'pay_slips.workers.edit',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/pay_slips/workers/view/:id',
            name: 'pay_slips.workers.view',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/pay_slips/blank/view/:id',
            name: 'pay_slips.blank.view',
            component: () => import('@/views/PaySlip/Form/BlankPaySlipPreview.vue'),
            props: {viewAction: true}
        },
        {
            path: '/pay_slips/print/:annexId',
            name: 'pay_slips.print',
            component: () => import('@/views/PaySlip/Form/PrintPaySlip.vue'),
        },
        {
            path: '/pay_slips/print/journal/:annexId',
            name: 'pay_slips.journal',
            component: () => import('@/views/PaySlip/Form/PrintJournalPay.vue'),
        },
        {
            path: '/pay_slips/etat_recapitulatif/:id',
            name: 'pay_slips.etat_recapitulatif',
            component: () => import('@/views/PaySlipSynthesis/EtatRecapitulatif.vue'),
        },
        {
            path: '/pay_slips/documents/:id',
            name: 'pay_slips.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "PAY_SLIP"}
        },
    ]
}


export const BlankPaySlip = {
    path: '/blank_pay_slips',
    name: 'blank_pay_slips',
    component: () => import('@/views/BlankPaySlip/BlankPaySlipPage.vue'),
    children: [
        {
            path: '/blank_pay_slips/workers/view/:id',
            name: 'blank_pay_slips.workers.view',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {viewAction: true}
        },
    ]
}

export const PaySlipConfiguration = {
    path: '/pay_slips_configuration',
    name: 'pay_slips_configuration',
    component: () => import('@/views/PaySlip/Form/PaySlipConfiugration.vue'),
}